import React, { useContext, useState } from 'react';
import { Slider, Typography } from 'antd';
import { PiEngineBold } from 'react-icons/pi';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const EngineIdleAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [min, setMin] = useState(5);
  const [loading, setLoading] = useState(false);

  const triggerEngineAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: min, threshold: '3' }, credentials, ALERT_CATEGORY.ENGINE_IDLE_ALERT)
      .then(() => { messageApi.success('Engine idle alert triggered successfully'); onTriggered?.({ success: true, value: `${min} mins` }); })
      .catch(() => { messageApi.error('Failed to trigger engine idle alert'); onTriggered?.({ success: false, value: `${min} mins` }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={10}
      title="Engine Idle"
      icon={<PiEngineBold />}
      iconBg="#f5f3ff"
      iconColor="#7c3aed"
      threshold="3 mins"
      onTrigger={triggerEngineAlert}
      triggerLabel="Trigger Engine Idle Alert"
      loading={loading}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 11, color: '#64748b' }}>Idle duration</Text>
        <Text style={{ fontSize: 20, fontWeight: 700, color: min > 3 ? '#ef4444' : '#0f172a', lineHeight: 1 }}>
          {min} <span style={{ fontSize: 12, fontWeight: 500, color: '#94a3b8' }}>mins</span>
        </Text>
      </div>
      <Slider min={3} max={20} value={min} onChange={setMin} />
    </AlertCard>
  );
};

export default EngineIdleAlert;
